module.exports = __webpack_public_path__ + "static/media/client-logo-29.2311923f.jpg";